module.exports = __webpack_public_path__ + "img/sale_eg.f9c96b30.jpg";